import React, { useEffect, useState } from 'react'
import {
  Panel,
  Row,
  Col,
  SelectPicker,
  Checkbox,
  Uploader,
  ControlLabel,
  Message,
  Icon,
  IconButton,
  Table,
  ButtonGroup,
  Whisper,
  Tooltip,
  CheckboxGroup,
} from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import InputForm from '../../../components/forms/input/InputForm'
import { isImageOrPdf, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import { cloneDeep, isEmpty, values } from 'lodash-es'
import notification from '../../../utils/notification'
import { getValueFromOptions } from '../../../utils/dataUtil'
import CKEditorBlankFrom from '../../../components/forms/input/CKEditorBlankFrom'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { downloadAuditfilesAttachments } from '../../../redux/actions/reportsAudit'
import { doneLoading, startLoading } from '../../../utils/loading'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { callInfomaDownloadService } from '../../attachfiles/AttachFilesViewDownload'
import moment from 'moment'
import { DD_MM_YYYY_SLASH } from '../../../constants/date'
import ReactQuillFrom from '../../../components/forms/input/ReactQuill/ReactQuillFrom'
import AlertWidget from '../../confirm/AlertWidget'

export default function FollowAuditIssuesForm({
  schema: _schema,
  projectInfo,
  auditRole,
  loading,
  register,
  Controller,
  control,
  errors,
  getValues,
  setValue,
  clearErrors,
  onSearch = () => {},
  onSubmitDraftOne = () => {},
  disabled,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [projectGrade, setProjectGrade] = useState()
  const [auditResults, setAuditResults] = useState()
  const [formSchema, setFormSchema] = useState()
  const [checkRadio, setCheckRadio] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const [otherAttach, setOtherAttach] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [auditBudgetValues, setAuditBudgetValues] = useState(_)

  const [mapSelected, setMapSelected] = useState()
  const [disabledApproveOption, setDisabledApproveOption] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isShowAlert, setIsShowAlert] = useState(false)
  const [msgError, setMsgError] = useState('')

  const headerStyle = {
    textAlign: 'center',
    borderBottom: '1px solid #d3caca',
    borderTop: '1px solid #d3caca',
    backgroundColor: '#e4e5e7',
    padding: 0,
  }

  const rowStyle = {
    marginTop: 10,
    border: '1px solid #d3caca',
    borderTop: 'none',
  }

  const leftColStyle = {
    borderRight: '1px solid #d3caca',
    padding: 0,
  }

  const rightColStyle = {
    borderLeft: '1px solid #d3caca',
    padding: 0,
  }

  useEffect(() => {
    setFormSchema(_schema)

    if (!_schema?.coordinatorOption.value || _schema?.coordinatorOption.value?.length === 0) {
      setValue(_schema?.coordinatorOption.name, undefined)
      register(_schema?.coordinatorOption.name, undefined)
      setCheckRadio([])
    } else {
      setCheckRadio(_schema?.coordinatorOption?.value || [])
      register(_schema?.coordinatorOption.name)
      setValue(_schema?.coordinatorOption.name, [..._schema?.coordinatorOption?.value])
    }
    // let newArr = cloneDeep(trackingResultsValue)
    register('validApproveOption', false)
    checkRadioTrackingResults()
  }, [_schema])

  // console.log('checkRadio', checkRadio)

  useEffect(() => {
    setAuditBudgetValues(_schema?.auditBudget?.values || [])
  }, [_schema?.auditBudget?.values])

  useEffect(() => {
    register('deleteFileIds', [])

    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values.length > 0) {
      setOtherAttach(formSchema?.attachFiles?.values)
    }
  }, [formSchema])

  let ResultsColor = ' '
  switch (formSchema?.auditorOption?.value) {
    case 1:
      ResultsColor = '#70b144'
      break
    case 2:
      ResultsColor = '#ffbd09'
      break
    case 3:
      ResultsColor = '#fb0403'
      break

    default:
      break
  }

  const onTrackingResultChange = (key, value) => {
    console.log(key, value)
    let map = new Map()

    if (mapSelected) {
      map = cloneDeep(mapSelected)
    }

    map.set(key, value)

    setValueDisabledApprove(map)
  }

  const checkRadioTrackingResults = () => {
    if (_schema?.issueList?.length > 0) {
      let map = new Map()
      _schema?.issueList.map((issueList) => {
        if (issueList.issues.length > 0) {
          issueList.issues.map((issues) => {
            if (issues.risks.length > 0) {
              issues.risks.map((risks) => {
                map.set(
                  issues.issueCode + '_' + risks.id + '_trackingResults',
                  risks.trackingResults
                )
              })
            }
          })
        }
      })

      setValueDisabledApprove(map)
    }
  }

  const setValueDisabledApprove = (map) => {
    var result = false
    for (let [key, value] of map) {
      console.log('map ', key, value)
      if (value != 1) {
        result = true
      }
    }
    console.log('result => ', result)
    if (disabledApproveOption != result && formSchema) {
      setCheckRadio([])
      setValue(_schema.coordinatorOption.name)
    }
    setDisabledApproveOption(result)
    setValue('validApproveOption', result)

    setMapSelected(map)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadAuditfilesAttachments(fileObj.path)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    console.log('file => ', fileObj)
    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadAuditfilesAttachments(fileObj.path)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreviewInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    console.log('fileObj => ', fileObj)
    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'preview')

      error ? setIsError('แสดง') : setIsError()
    } else {
      setIsError('แสดง')
    }
  }

  const onDownloadInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'download')

      error ? setIsError('ดาวน์โหลด') : setIsError()
    } else {
      setIsError('ดาวน์โหลด')
    }
  }

  const handleDeleteFileIssue = (item) => {
    console.log('handleDeleteFileIssue', item)

    let arr = getValues('deleteFileIds') || []
    arr.push(item.fileId)
    setValue('deleteFileIds', arr)

    setFormSchema((state) => ({
      ...state,
      issueList: state.issueList.map((e) => {
        return {
          ...e,
          issues: e.issues.map((q) => {
            if (item.issueCode == q.issueCode) {
              return { ...q, fileName: null, filePath: null }
            } else {
              return { ...q }
            }
          }),
        }
      }),
    }))
  }

  const handleDeleteFileotherAttach = (rowData) => {
    console.log('handleDeleteFileotherAttach ', rowData)

    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    const filesData = cloneDeep(otherAttach)
    let _filesData = filesData?.filter((item) => item.id != rowData.id)
    setOtherAttach(_filesData)
  }

  const handleSubmitDraftOne = (id) => {
    onSubmitDraftOne()
  }

  const generateRiskBlockNew = (
    riskSchema,
    risk,
    questionid,
    issueListIndex,
    issuesIndex,
    riskIndex
  ) => {
    var id = questionid + '_' + risk.id + '_'

    return (
      <Panel key={id} bordered style={{ marginTop: 10 }}>
        <Row style={{ marginTop: 10 }}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{`ระดับความเสี่ยง : ${getValueFromOptions(
                riskSchema.risk.options,
                risk.risk
              )}`}</p>
            </Col>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Row style={rowStyle}>
            <Col lg={12} md={12} sm={24} xs={24} style={leftColStyle}>
              <p style={headerStyle}>{riskSchema?.issuesDetected?.label}</p>
              <div
                style={{ wordWrap: 'break-word', padding: 5 }}
                dangerouslySetInnerHTML={{
                  __html: risk?.issuesDetected,
                }}
              />
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={rightColStyle}>
              <p style={headerStyle}>{riskSchema?.explanation?.label}</p>
              <div
                style={{ wordWrap: 'break-word', padding: 5 }}
                dangerouslySetInnerHTML={{
                  __html: risk?.explanation,
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ padding: 0 }}>
              <p
                style={{
                  textAlign: 'center',
                  border: '1px solid #d3caca',
                  backgroundColor: '#e4e5e7',
                  padding: 0,
                  marginTop: 5,
                }}
              >
                {riskSchema?.trackingResults?.label}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              <ErrorMessage error={errors[id + riskSchema?.trackingResults?.name]} />
              <Controller
                name={id + riskSchema?.trackingResults?.name}
                control={control}
                defaultValue={risk?.trackingResults}
                rules={isValidators(riskSchema?.trackingResults?.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={riskSchema?.trackingResults?.options}
                      value={props.value}
                      style={{ marginTop: '5px', width: '100%' }}
                      searchable={false}
                      placeholder={'เลือก' + riskSchema?.trackingResults?.label}
                      onChange={(value) => {
                        console.log('value => ', value)
                        props.onChange(value)

                        onTrackingResultChange(id + riskSchema?.trackingResults?.name, value)

                        // if (disabledApproveOption && checkRadio == 1) {
                        //   setIsShowAlert(true)
                        // }
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {/* inptBlock2 */}
              {!riskSchema?.detectedIssues?.inputDetectedIssues?.disabled ? (
                <div style={{ padding: '0px 5px 0px 5px', marginTop: -5 }}>
                  {/* <ReactQuillFrom
                    schema={riskSchema?.trackingResultsDetail}
                    value={risk?.trackingResultsDetail}
                    name={id + riskSchema?.trackingResultsDetail?.name}
                    toolbar={[]}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    toolbars={[[]]}
                  /> */}
                  <CKEditorBlankFrom
                    schema={riskSchema?.trackingResultsDetail}
                    value={risk?.trackingResultsDetail}
                    name={id + riskSchema?.trackingResultsDetail?.name}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideToolbar={true}
                    noControlLabel={true}
                  />
                </div>
              ) : (
                <>
                  <div
                    style={{ wordWrap: 'break-word' }}
                    dangerouslySetInnerHTML={{
                      __html: riskSchema?.trackingResultsDetail?.value,
                    }}
                  />
                </>
              )}
            </Col>
          </Row>
          {!disabled && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={20} md={20} sm={24} xs={24}></Col>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <SaveButton
                  onClick={() => {
                    handleSubmitDraftOne(id)
                  }}
                >
                  {'บันทึกร่าง'}
                </SaveButton>
              </Col>
            </Row>
          )}
        </Row>
      </Panel>
    )
  }

  const panelInput = (item, issueListIndex, issuesIndex) => {
    // console.log('item==>', item)
    let issueFile = []
    if (item?.filePath) {
      issueFile.push({
        label: item?.fileName || '',
        path: item?.filePath || '',
      })
    }

    return (
      <>
        {item.risks?.map((risk, index) => {
          return (
            !risk?.isDeleted &&
            risk.id &&
            generateRiskBlockNew(
              _schema.issueForm,
              risk,
              item.issueCode,
              issueListIndex,
              issuesIndex,
              index
            )
          )
        })}

        <Row style={{ marginTop: 10 }}>
          <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                _schema.issueForm.attachFiles.validators,
                _schema.issueForm.attachFiles.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={19} md={19} sm={24} xs={24}>
            {!item.filePath && (
              <>
                <ErrorMessage
                  error={errors[item.issueCode + '_' + _schema.issueForm.attachFiles.name]}
                />

                <Controller
                  key={item.issueCode + '_' + _schema.issueForm.attachFiles.name}
                  name={item.issueCode + '_' + _schema.issueForm.attachFiles.name}
                  control={control}
                  rules={isValidators(_schema.issueForm.attachFiles.validators)}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={_schema.issueForm.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                        autoUpload={false}
                        disabled={_schema.issueForm.attachFiles.disabled}
                        fileListVisible={true}
                        // listType="picture-text"
                        fileList={props.value || []}
                        multiple={false}
                        // draggable
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let files = []
                            files.push(fileList[fileList.length - 1])

                            props.onChange(files)
                          }
                        }}
                      >
                        <div>
                          <Icon size="2x" icon="upload2" />
                          <small className="uploder__text"></small>
                          {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                            _schema.issueForm.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                          }`}
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </>
            )}

            {item?.filePath && (
              <div>
                <IncomeRecordFileTable
                  data={issueFile}
                  deleteable={!disabled}
                  onPreview={onPreview}
                  onDownload={onDownload}
                  onDelete={() => {
                    handleDeleteFileIssue(item)
                  }}
                />
              </div>
            )}
          </Col>
        </Row>
      </>
    )
  }

  const generateAuditBudgetNew = (valuesIndex, valuesItem) => {
    return (
      <>
        <Row style={{ marginBottom: 10 }} key={valuesIndex}>
          <Col lg={1} md={1} sm={24} xs={24}>
            {`${valuesIndex + 1}.)`}
          </Col>
          <Col lg={3} md={3} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditPeriod.label + ' : '}</ControlLabel>
            {valuesItem.auditPeriod || '0'}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorCompany.label + ' : '}</ControlLabel>
            {valuesItem.auditorCompany || ''}
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorName.label + ' : '}</ControlLabel>
            {valuesItem.auditorName || ''}
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorLicenseNumber.label + ' : '}</ControlLabel>
            {valuesItem.auditorLicenseNumber || ''}
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formSchema && (
        <>
          <Panel
            header={'ประเด็นตรวจสอบภายใน'}
            bordered
            collapsible
            defaultExpanded
            style={{ marginTop: 20 }}
          >
            <Panel bordered header={'รายงานตรวจสอบฉบับสมบูรณ์'}>
              <>
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={`เกิดข้อผิดพลาดในการ${isError} กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                    />
                  </Row>
                )}
                <Row>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <b>กำกับ/ประเมินผล/ตรวจสอบ</b>
                  </Col>
                  <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <ButtonGroup>
                      <Whisper
                        placement="top"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            คลิกเพื่อ <i>แสดงไฟล์</i>
                          </Tooltip>
                        }
                      >
                        <IconButton
                          appearance="ghost"
                          size="sm"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          disabled={
                            !formSchema?.auditBook?.value.find(
                              (e) => e.name.indexOf('06') != -1 && e.path != ''
                            )
                          }
                          onClick={(e) => onPreviewInfoma()}
                        />
                      </Whisper>

                      <Whisper
                        placement="top"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            คลิกเพื่อ <i>ดาวน์โหลดไฟล์</i>
                          </Tooltip>
                        }
                      >
                        <IconButton
                          appearance="ghost"
                          size="sm"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          disabled={
                            !formSchema?.auditBook?.value.find(
                              (e) => e.name.indexOf('06') != -1 && e.path != ''
                            )
                          }
                          onClick={(e) => onDownloadInfoma()}
                        />
                      </Whisper>
                    </ButtonGroup>
                  </Col>
                </Row>
              </>
            </Panel>
            <Panel>
              <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.auditByCompany.label}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {`  :  ${formSchema.auditByCompany.value || ''}`}
                </Col>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.auditName.label}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {`  :  ${formSchema.auditName.value || ''}`}
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>{formSchema.auditPeriod.label}</ControlLabel>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {`  :  ${formSchema.auditPeriod.value || ''}`}
                </Col>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>{formSchema.auditDate.label}</ControlLabel>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {formSchema?.auditDate?.value
                    ? moment(moment(formSchema?.auditDate?.value).toDate()).format(DD_MM_YYYY_SLASH)
                    : ''}
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.auditorLicenseNumber.label}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {`  :  ${formSchema.auditorLicenseNumber.value || ''}`}
                </Col>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.auditBudgetYear.label}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {`  :  ${formSchema.auditBudgetYear.value || ''}`}
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {`${formSchema.auditResults.label} :`}
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <div>
                    <Icon
                      icon="circle"
                      size="lg"
                      style={{ marginRight: 5, marginTop: 5, color: ResultsColor }}
                    />
                    {/* {` ${formSchema.auditorOption.valueDef || ''}`} */}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formSchema?.auditorOption?.valueDef || '',
                      }}
                      style={{ marginLeft: 10, marginTop: 2 }}
                    />
                  </div>
                </Col>
              </Row>

              <Row style={{ marginTop: 20 }}>
                <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  ตรวจสอบการใช้จ่ายเงินโดยบริษัท
                </Col>
                <Col lg={20} md={20} sm={24} xs={24}>
                  <Panel bordered>
                    {auditBudgetValues.map((item, index) => {
                      return generateAuditBudgetNew(index, item)
                    })}
                  </Panel>
                </Col>
              </Row>

              <Row style={{ marginTop: 20 }}>{formSchema.conclusion}</Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={18} md={18} sm={24} xs={24}>
                  {formSchema.description.label}
                  {`  :  ${formSchema.description.value || ''}`}
                </Col>

                <Col lg={6} md={6} sm={24} xs={24}>
                  {formSchema.projectGrade.label}
                  {`  :  ${
                    getValueFromOptions(
                      formSchema.projectGrade.options,
                      formSchema.projectGrade.value
                    ) || ''
                  }`}
                </Col>
              </Row>
              <hr />
            </Panel>

            {formSchema?.issueList?.map((element, i) => {
              return (
                <Panel header={element.title} collapsible defaultExpanded key={i}>
                  {element.issues?.map((item, index) => {
                    return (
                      <Panel
                        key={index}
                        header={
                          <div style={{ color: 'black' }}>
                            {item.issueCode + ' ' + item.issueName}
                          </div>
                        }
                        collapsible
                        defaultExpanded={item?.risks?.length > 0}
                        // defaultExpanded
                        style={{ marginTop: -20 }}
                      >
                        {panelInput(item, i, index)}
                      </Panel>
                    )
                  })}
                </Panel>
              )
            })}

            {formSchema.otherDesc && (
              <Row style={{ marginTop: 10 }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  {formSchema.otherDesc.label} :
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <div style={{ marginLeft: 20 }}>{formSchema.otherDesc.value || ''}</div>
                </Col>
              </Row>
            )}

            <hr />

            <Row style={{ marginTop: 10 }}>
              <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(_schema.attachFiles.validators, _schema.attachFiles.label)}
                </ControlLabel>
              </Col>
              <Col lg={19} md={19} sm={24} xs={24}>
                <ErrorMessage error={errors[_schema.attachFiles.name]} />
                <Controller
                  key={_schema.attachFiles.name}
                  name={_schema.attachFiles.name}
                  control={control}
                  rules={isValidators(_schema.attachFiles.validators)}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={_schema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                        autoUpload={false}
                        disabled={_schema.attachFiles.disabled}
                        fileListVisible={true}
                        // listType="picture-text"
                        fileList={props.value || []}
                        multiple
                        // draggable
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (isImageOrPdf(file.blobFile.type)) {
                              props.onChange(fileList)
                              // setFileTypeError(false)
                            } else {
                              // setFileTypeError(true)
                              notification.open('error', {
                                title: 'ชนิดที่รองรับ png, jpeg, jpg, pdf',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                      >
                        <div>
                          <Icon size="2x" icon="upload2" />
                          <small className="uploder__text"></small>
                          {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                            _schema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                          }`}
                        </div>
                      </Uploader>
                    )
                  }}
                />

                {otherAttach?.length > 0 && (
                  <div>
                    <IncomeRecordFileTable
                      data={otherAttach}
                      onPreview={onPreview}
                      onDownload={onDownload}
                      onDelete={(rowData) => handleDeleteFileotherAttach(rowData)}
                      deleteable={!disabled}
                    />
                  </div>
                )}
              </Col>
            </Row>
            {!auditRole?.isUser && (
              <>
                {formSchema.coordinatorOption && (
                  <Row>
                    <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {formSchema.coordinatorOption.label}
                    </Col>
                    <Col lg={19} md={19} sm={24} xs={24}>
                      <>
                        <ErrorMessage error={errors[formSchema.coordinatorOption.name]} />
                        {/* {console.log('disabledApproveOption==>', disabledApproveOption)} */}
                        {formSchema?.auditorOption?.value != 3 ? (
                          <Controller
                            key={formSchema.coordinatorOption.name}
                            name={formSchema.coordinatorOption.name}
                            control={control}
                            rules={isValidators(formSchema.coordinatorOption.validators)}
                            defaultValue={formSchema.coordinatorOption.value}
                            render={(props) => {
                              return (
                                <CheckboxGroup
                                  name={formSchema.coordinatorOption.name}
                                  // value={[1]}
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setCheckRadio(value)
                                    if (value.length === 0)
                                      setValue(formSchema.coordinatorOption.name)
                                  }}
                                >
                                  {formSchema.coordinatorOption.options.map((item, index) => {
                                    if (index == 0) {
                                      return (
                                        <Checkbox
                                          key={item.value}
                                          value={item.value}
                                          // disabled={disabledApproveOption}
                                        >
                                          <div style={{ display: 'flex' }}>
                                            <p
                                              dangerouslySetInnerHTML={{ __html: item.label }}
                                              style={{ marginTop: -3 }}
                                            />
                                          </div>
                                        </Checkbox>
                                      )
                                    }
                                  })}
                                </CheckboxGroup>
                              )
                            }}
                          />
                        ) : (
                          <Controller
                            key={formSchema.coordinatorOption.name}
                            name={formSchema.coordinatorOption.name}
                            control={control}
                            rules={isValidators(formSchema.coordinatorOption.validators)}
                            //defaultValue={formSchema.coordinatorOption.value || null}
                            render={(props) => {
                              return (
                                <CheckboxGroup
                                  name={formSchema.coordinatorOption.name}
                                  value={checkRadio}
                                  onChange={(value) => {
                                    props.onChange(value)
                                    setCheckRadio(value)
                                    if (value.length === 0)
                                      setValue(formSchema.coordinatorOption.name)
                                  }}
                                >
                                  {formSchema.coordinatorOption.options.map((item, index) => {
                                    if (index == 0) {
                                      return (
                                        <Checkbox
                                          key={item.value}
                                          value={item.value}
                                          disabled={disabledApproveOption}
                                        >
                                          <div style={{ display: 'flex' }}>
                                            <p
                                              dangerouslySetInnerHTML={{ __html: item.label }}
                                              style={{ marginTop: -3 }}
                                            />
                                            {disabledApproveOption && checkRadio == 1 && (
                                              <Icon
                                                icon="remind"
                                                size="lg"
                                                style={{
                                                  color: 'red',
                                                  marginLeft: 5,
                                                  marginTop: -8,
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Checkbox>
                                      )
                                    }
                                    return (
                                      <Checkbox
                                        key={item.value}
                                        value={item.value}
                                        disabled={!disabledApproveOption}
                                      >
                                        <p
                                          dangerouslySetInnerHTML={{ __html: item.label }}
                                          style={{ marginTop: -3 }}
                                        />
                                      </Checkbox>
                                    )
                                  })}
                                </CheckboxGroup>
                              )
                            }}
                          />
                        )}
                      </>
                    </Col>
                  </Row>
                )}

                {formSchema?.coordinatorComment && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={5} md={5} sm={24} xs={24}></Col>
                    <Col lg={19} md={19} sm={24} xs={24}>
                      <InputForm
                        schema={formSchema?.coordinatorComment}
                        value={formSchema?.name}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        hideLabel
                        componentClass="textarea"
                        placeholder={'ระบุความเห็นเพิ่มเติม'}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Panel>

          <AlertWidget
            title={`การแจ้งเตือน`}
            show={isShowAlert}
            size="sm"
            useHtmlTag
            detail={
              <div
                style={{ padding: 5 }}
                dangerouslySetInnerHTML={{
                  __html:
                    'ผลการติดตามการดำเนินรายประเด็นไม่สอดคล้องกับความเห็นโดยสรุปเพื่อเสนออนุมัติ',
                }}
              />
            }
            onClose={() => {
              setIsShowAlert(false)
            }}
          />
        </>
      )}
    </>
  )
}
